import { subject } from '@casl/ability';
import { type MemberAbility } from '@lightdash/common';
import useApp from '../providers/App/useApp';

export const canUserExportProjectData = (
    ability: MemberAbility,
    projectUuid: string,
    organizationUuid: string,
): boolean =>
    ability.can(
        'create',
        subject('Space', { projectUuid, organizationUuid }),
    );

export const useCanExportProjectData = (
    projectUuid: string | undefined,
): boolean => {
    const { user } = useApp();

    if (!projectUuid || !user.data) {
        return false;
    }

    return canUserExportProjectData(
        user.data.ability,
        projectUuid,
        user.data.organizationUuid,
    );
};

export const useCanViewSqlCard = (
    projectUuid: string | undefined,
): boolean => {
    const { user } = useApp();

    if (!projectUuid || !user.data) {
        return false;
    }

    return user.data.ability.can(
        'manage',
        subject('CustomSql', {
            projectUuid,
            organizationUuid: user.data.organizationUuid,
        }),
    );
};
